export function url($el) {
  const raw = $el.val().trim();
  if (!raw) {
    return true;
  }
  try {
    const url2 = new URL($el.val());
    return !$el.val().startsWith(" ") && !$el.val().endsWith(" ") && (url2.protocol === "http:" || url2.protocol === "https:");
  } catch (e) {
    return false;
  }
}
Foundation.Abide.defaults.validators["url"] = url;
